import { useEffect } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { getBlogs } from "../../features/admin3/admin3Slice"
import { useSelector } from "react-redux"
import BlogTabSide from "../../components/blogs/BlogTabSide"
import BlogContentSide from "../../components/blogs/BlogContentSide"

const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            display: flex;
            justify-content: space-between;
            padding: 30px;

        }
    }
`


const KamyoonWebBlogs = () => {

    const dispatch = useDispatch()
    const {webBlogList} = useSelector((state) => state.admin3)

    useEffect(() => {
        dispatch(getBlogs())
    }, [])
    
  return (
    <Container>
        <div className="wrapper">
            <PageTopTitle title={"Bloglar"} position="sticky" />
            <div className="content">
            
                <BlogTabSide />
                <BlogContentSide />
                
            </div>
        </div>
    </Container>
  )
}

export default KamyoonWebBlogs